import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da25d3ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = { class: "contain" }
const _hoisted_3 = { class: "back-arrow" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = { class: "el-dropdown-item" }
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = { class: "project-information" }
const _hoisted_9 = {
  key: 0,
  class: "project-total"
}
const _hoisted_10 = { style: {"font-family":"DIN Alternate-Bold, DIN Alternate","font-size":"2vw"} }
const _hoisted_11 = {
  key: 1,
  class: "project-total"
}
const _hoisted_12 = { style: {"font-family":"DIN Alternate-Bold, DIN Alternate","font-size":"2vw"} }
const _hoisted_13 = {
  key: 2,
  class: "project-total"
}
const _hoisted_14 = { style: {"font-family":"DIN Alternate-Bold, DIN Alternate","font-size":"2vw"} }
const _hoisted_15 = { class: "project-status1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "project-status-font" }, "进行中", -1))
const _hoisted_17 = { class: "project-status-number" }
const _hoisted_18 = { class: "project-status2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "project-status-font" }, "已暂停", -1))
const _hoisted_20 = { class: "project-status-number" }
const _hoisted_21 = { class: "project-status3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "project-status-font" }, "已完成", -1))
const _hoisted_23 = { class: "project-status-number" }
const _hoisted_24 = { class: "project-status4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "project-status-font" }, "已归档", -1))
const _hoisted_26 = { class: "project-status-number" }
const _hoisted_27 = { class: "project-status5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "project-status-font" }, "待开始", -1))
const _hoisted_29 = { class: "project-status-number" }
const _hoisted_30 = { class: "selectors" }
const _hoisted_31 = { class: "m-2" }

import { ref, onMounted } from 'vue';
import rectChart from '@/components/rectChart.vue';
import { useRoute, useRouter } from 'vue-router';
import router from '@/router';
import javaapi from '@/service/javaapi';
import God from "@/service/god"

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgramContent',
  setup(__props) {

let type = ref('')

const rotuer = useRouter()
const route = useRoute()
onMounted(() => {
  //console.log("路由", route.query)
  type.value = route.query.type + '';
  new God()._correct()
  init();
})
const back = () => {
  router.push({
    name: 'Program'
  });
}
const activeName = ref("all");
const number = ref(0);
const ongoing_num = ref(0);
const paused_num = ref(0);
const completed_num = ref(0);
const archived_num = ref(0)
const will_num = ref(0)
const getNumbers = () => {
  number.value = 0
  ongoing_num.value = 0
  paused_num.value = 0
  completed_num.value = 0
  archived_num.value = 0
  will_num.value = 0
  number.value = projectInfos.value.length;
  projectInfos.value.forEach((data) => {
    if (data.status == '进行中') {
      ongoing_num.value++
    }
    if (data.status == '已暂停') {
      paused_num.value++
    }
    if (data.status == '已完成') {
      completed_num.value++
    }
    if (data.status == '已归档') {
      archived_num.value++
    }
    if (data.status == '待开始') {
      will_num.value++
    }
  })
}

const handleCommand = (command: string | number | object) => {
  type.value = <string>command
  router.push({
    name: "ProgramContent",
    query: {
      type: type.value
    },
  });
  init()

}

const projectInfos = ref([{

  "checkup_project_id": 0,
  "type": "",
  "organization_name": "",
  "name": "",
  "status": "",
  "score": 0,
  "standard_score": 0,
  "start_date": "",
  "end_date": "",
  "added_user": "",
  "charge_user": "",
  "completed_num": 0,
  "incomplete_num": 0,
  "completed_percentage": 0,
  "expert_num": 0,
  "level":'',

}])

const init = async () => {
  searchInstitution.value = ""
  searchStatus.value = ""
  searchInstitutions.value.length = 0
  searchStatuses.value.length = 0
  searchTime.value.length = 0
  projectInfos.value.length = 0;
  let is_organization_distribute = '2';
  if (activeName.value == 'join') {
    is_organization_distribute = '1'
  }
  if (activeName.value == 'create') {
    is_organization_distribute = '0'
  }
  const query = {
    jsonText: { "organization_id": localStorage.getItem('organization_id'), "type": type.value, "is_organization_distribute": is_organization_distribute },
    token: localStorage.getItem('token'),
    user_id: localStorage.getItem('user_id'),
  }
  const result = await javaapi.postQuery(query, '/project/getProjectInfo')
  if (result.status == 1) {
    projectInfos.value = [...result.data].reverse()
    //console.log(projectInfos.value)
  }
  institutions.value.length = 0;
  projectInfos.value.forEach((data) => {
    if (!institutions.value.find((item) => item == data.organization_name)) {
      institutions.value.push(data.organization_name)
    }
  })
  console.log("项目结果：",projectInfos.value);
  
  getNumbers()
}

const search = async () => {
  projectInfos.value.length = 0;
  let is_organization_distribute = '2';
  if (activeName.value == 'join') {
    is_organization_distribute = '1'
  }
  if (activeName.value == 'create') {
    is_organization_distribute = '0'
  }
  const query = {
    jsonText: {
      "organization_id": localStorage.getItem('organization_id'),
      "type": [type.value],
      "status": searchStatuses.value.length == 0 ? projectStatus.value : searchStatuses.value,
      "is_organization_distribute": is_organization_distribute,
      "start_date": searchTime.value == null || searchTime.value.length == 0 ? '1900-01-01' : searchTime.value[0],
      "end_date": searchTime.value == null || searchTime.value.length == 0 ? '9999-12-31' : searchTime.value[1]
    },
    token: localStorage.getItem('token'),
    user_id: localStorage.getItem('user_id'),
  }
  const result = await javaapi.postQuery(query, '/project/searchProjectInfo')
  if (result.status == 1) {

    result.data.forEach((data) => {
      if (searchInstitutions.value.length == 0 || searchInstitutions.value.find((item) => item == data.organization_name)) {
        projectInfos.value.push(data)
      }
    })
    //console.log(projectInfos.value)
  }
  getNumbers()

}







const projectStatus = ref<string[]>([
  "进行中",
  "已暂停",
  "已完成",
  "已归档",
  "待开始"
])

const types = ref<string[]>([
  "政府考核",
  "安全标准化评价",
  "安全示范城市化创建",
  "安全检查",
])

const institutions = ref<string[]>([
  "陕西省应急厅",
  "西安市雁塔区",
  "西安市应急管理局",
])

const searchStatus = ref()
const searchInstitution = ref()
const searchStatuses = ref([])
const searchInstitutions = ref([])
const searchTime = ref([])

const statusChange = () => {
  searchStatuses.value.length = 0;
  if (searchStatus.value != "") {
    searchStatuses.value.push(searchStatus.value);
  }
}


const institutionChange = () => {
  searchInstitutions.value.length = 0
  if (searchInstitution.value != "") {
    searchInstitutions.value.push(searchInstitution.value);
  }
}
const clearSearch = () => {
  init()
}


const shortcuts = [
  {
    text: '上周',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      return [start, end]
    },
  },
  {
    text: '上个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      return [start, end]
    },
  },
  {
    text: '三个月前',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      return [start, end]
    },
  },
]


return (_ctx: any,_cache: any) => {
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, {
          onClick: back,
          style: {"color":"white","font-size":"1.8vw","cursor":"pointer"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Back)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_dropdown, {
          class: "el-dropdown",
          onCommand: handleCommand,
          trigger: "click"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, { class: "el-dropdown-menu" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, { command: item }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(type) + '类') + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CaretBottom)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
          class: "tabs1",
          onTabChange: _cache[1] || (_cache[1] = ($event: any) => (init()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              class: "el-tab-pane",
              label: "全部",
              name: "all"
            }),
            _createVNode(_component_el_tab_pane, {
              class: "el-tab-pane",
              label: "参与项目",
              name: "join"
            }),
            _createVNode(_component_el_tab_pane, {
              class: "el-tab-pane",
              label: "发起项目",
              name: "create"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (activeName.value == 'all')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createTextVNode("项目总数："),
              _createElementVNode("span", _hoisted_10, _toDisplayString(number.value), 1)
            ]))
          : _createCommentVNode("", true),
        (activeName.value == 'join')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createTextVNode("参与项目总数："),
              _createElementVNode("span", _hoisted_12, _toDisplayString(number.value), 1)
            ]))
          : _createCommentVNode("", true),
        (activeName.value == 'create')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createTextVNode("发起项目总数："),
              _createElementVNode("span", _hoisted_14, _toDisplayString(number.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(ongoing_num.value), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(paused_num.value), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("span", _hoisted_23, _toDisplayString(completed_num.value), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, _toDisplayString(archived_num.value), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("span", _hoisted_29, _toDisplayString(will_num.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_select, {
                    clearable: "",
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    modelValue: searchStatus.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchStatus).value = $event)),
                    onClear: clearSearch,
                    onChange: statusChange,
                    placeholder: "请选择项目状态"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectStatus.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_select, {
                    clearable: "",
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    modelValue: searchInstitution.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchInstitution).value = $event)),
                    onClear: clearSearch,
                    onChange: institutionChange,
                    placeholder: "请选择机构"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(institutions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 7 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_el_date_picker, {
                    style: {"width":"100%"},
                    "value-format": "YYYY-MM-DD",
                    modelValue: searchTime.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchTime).value = $event)),
                    type: "daterange",
                    "unlink-panels": "",
                    shortcuts: shortcuts,
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    onClear: clearSearch
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  onClick: search,
                  class: "el-icon--search",
                  style: {"color":"white","position":"relative","top":"15%","font-size":"1.5vw","cursor":"pointer"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Search)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row)
      ]),
      _createVNode(_component_el_scrollbar, {
        class: "rectChartContent",
        "max-height": "40vh"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(projectInfos.value.length / 3), (i) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createVNode(_component_el_row, {
                gutter: 0,
                style: {"position":"relative","width":"97%","left":"3%","height":"40vh","margin-bottom":"6vh"}
              }, {
                default: _withCtx(() => [
                  ((i - 1) * 3 + 1 <= projectInfos.value.length)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(rectChart, {
                            checkup_project_id: projectInfos.value[(i - 1) * 3].checkup_project_id,
                            type: projectInfos.value[(i - 1) * 3].type,
                            organization_name: projectInfos.value[(i - 1) * 3].organization_name,
                            name: projectInfos.value[(i - 1) * 3].name,
                            status: projectInfos.value[(i - 1) * 3].status,
                            score: projectInfos.value[(i - 1) * 3].score,
                            standard_score: projectInfos.value[(i - 1) * 3].standard_score,
                            start_date: projectInfos.value[(i - 1) * 3].start_date,
                            end_date: projectInfos.value[(i - 1) * 3].end_date,
                            added_user: projectInfos.value[(i - 1) * 3].added_user,
                            charge_user: projectInfos.value[(i - 1) * 3].charge_user,
                            completed_percentage: projectInfos.value[(i - 1) * 3].completed_percentage,
                            expert_num: projectInfos.value[(i - 1) * 3].expert_num,
                            level: projectInfos.value[(i - 1) * 3].level,
                            isFromProject: '1'
                          }, null, 8, ["checkup_project_id", "type", "organization_name", "name", "status", "score", "standard_score", "start_date", "end_date", "added_user", "charge_user", "completed_percentage", "expert_num", "level"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  ((i - 1) * 3 + 2 <= projectInfos.value.length)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 1,
                        span: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(rectChart, {
                            checkup_project_id: projectInfos.value[(i - 1) * 3 + 1].checkup_project_id,
                            type: projectInfos.value[(i - 1) * 3 + 1].type,
                            organization_name: projectInfos.value[(i - 1) * 3 + 1].organization_name,
                            name: projectInfos.value[(i - 1) * 3 + 1].name,
                            status: projectInfos.value[(i - 1) * 3 + 1].status,
                            score: projectInfos.value[(i - 1) * 3 + 1].score,
                            standard_score: projectInfos.value[(i - 1) * 3 + 1].standard_score,
                            start_date: projectInfos.value[(i - 1) * 3 + 1].start_date,
                            end_date: projectInfos.value[(i - 1) * 3 + 1].end_date,
                            added_user: projectInfos.value[(i - 1) * 3 + 1].added_user,
                            charge_user: projectInfos.value[(i - 1) * 3 + 1].charge_user,
                            completed_percentage: projectInfos.value[(i - 1) * 3 + 1].completed_percentage,
                            expert_num: projectInfos.value[(i - 1) * 3 + 1].expert_num,
                            level: projectInfos.value[(i - 1) * 3  + 1].level,
                            isFromProject: '1'
                          }, null, 8, ["checkup_project_id", "type", "organization_name", "name", "status", "score", "standard_score", "start_date", "end_date", "added_user", "charge_user", "completed_percentage", "expert_num", "level"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  ((i - 1) * 3 + 3 <= projectInfos.value.length)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 2,
                        span: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(rectChart, {
                            checkup_project_id: projectInfos.value[(i - 1) * 3 + 2].checkup_project_id,
                            type: projectInfos.value[(i - 1) * 3 + 2].type,
                            organization_name: projectInfos.value[(i - 1) * 3 + 2].organization_name,
                            name: projectInfos.value[(i - 1) * 3 + 2].name,
                            status: projectInfos.value[(i - 1) * 3 + 2].status,
                            score: projectInfos.value[(i - 1) * 3 + 2].score,
                            standard_score: projectInfos.value[(i - 1) * 3 + 2].standard_score,
                            start_date: projectInfos.value[(i - 1) * 3 + 2].start_date,
                            end_date: projectInfos.value[(i - 1) * 3 + 2].end_date,
                            added_user: projectInfos.value[(i - 1) * 3 + 2].added_user,
                            charge_user: projectInfos.value[(i - 1) * 3 + 2].charge_user,
                            completed_percentage: projectInfos.value[(i - 1) * 3 + 2].completed_percentage,
                            expert_num: projectInfos.value[(i - 1) * 3 + 2].expert_num,
                            level: projectInfos.value[(i - 1) * 3 + 2].level,
                            isFromProject: '1'
                          }, null, 8, ["checkup_project_id", "type", "organization_name", "name", "status", "score", "standard_score", "start_date", "end_date", "added_user", "charge_user", "completed_percentage", "expert_num", "level"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 256))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})